// Kept separate so tests can mock it. Surfaces as an unhandled rejection on the
// triggering router.push() — filtered via isNavigationBlockedRejection in packages/sentry.
export const stopRouting = () => {
  throw {
    name: 'NavigationBlocked',
    message: 'Navigation blocked due to unsaved changes.',
  };
};
